// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-7b6775d4] {\n  font-size: 1.6rem;\n  margin-top: 2rem;\n}", ""]);
// Exports
module.exports = exports;
